module.exports = __webpack_public_path__ + "static/media/help-img-1-1.68378579.png";